<template>
	<div >
	  <mu-appbar style="width: 100%;" color="#2196f3" >  
			 <mu-button icon slot="left"  @click="goback">
               <mu-icon  value="arrow_back"></mu-icon>
         </mu-button>
         <mu-button icon slot="right"  @click="refresh">
               <mu-icon  value="refresh"></mu-icon>
         </mu-button>
		
			提现记录
      </mu-appbar>

  <div v-if="datalist.length>0">

    <div v-for="item,index in datalist" :key="item.time" >
            <mu-row style="font-size: 0.6rem;padding: 10px;">
                <mu-col style="align-items: center;">
                    <div style="text-align: left">
                        <div style="padding: 0.2rem">时间:{{item.time}}</div>
                        <div style="padding: 0.2rem">金额:<strong style="color: red;">{{item.value}}</strong></div>
                    </div>
                </mu-col>

                <mu-col style="align-items: center;height: 100%;">
                    <div style="color: gray;padding: 0.2rem">{{item.state}}</div>
                     <div>{{item.desc}}</div>
                </mu-col>
              
            </mu-row>
            <div style="height: 0.5rem;background-color: #eeeeee"></div>
        </div>
       
    </div>
      <v-else >
        
    <van-empty description="没有记录" />
  </v-else>
  </div>


</template>
<script type="text/javascript">
  import Api from '@/api'
	export default {
     
     created(){
       this.refresh();
     },
		 data(){
           return {
           	columns:[

           	    {title:"金额",name:'value',width:50},
           	    {title:"时间",name:'time'},
                {title:"状态",name:'state'},
                {title:"描述",name:'desc'}

           	],
           	datalist:[
           	 
           	]
           }
		  },

         methods:{
          refresh()
          {
                Api.getTiXianRecord().then((res)=>{
                this.datalist=res.data;
        })
          },
         	goback(){
         		this.$router.go(-1);
         	}
         }
	}
</script>
<style type="text/css" scoped="">
  .mu-table  td {
    padding: 0;
    text-align: center;
  }
  .mu-table th {
     padding: 0;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/pages/TixianRecord.vue